import React, { useEffect, useState } from "react";
import classes from "./WinnersPage.module.css";
import { motion } from "framer-motion";
import { FaArrowLeft, FaClock } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { winnersLeaderboardApi } from "../http/http";
import { useTranslation } from "react-i18next";

const getInitials = (name = "") =>
    name
        ?.split(" ")
        .map((item) => item[0])
        .join("")
        .slice(0, 2)
        .toUpperCase();

const formatTime = (seconds = 0) => {
    const totalSeconds = Number(seconds) || 0;

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
    }

    if (minutes > 0) {
        return `${minutes}m ${secs}s`;
    }

    return `${secs}s`;
};

const WinnersPage = () => {
    const navigate = useNavigate();
    const { user } = useSelector((state) => state?.persisted?.userSlice);

    const [leaderboard, setLeaderboard] = useState([]);
    const [loading, setLoading] = useState(true);
    const {t}=useTranslation();

    const fetchLeaderboard = async () => {
        try {
            setLoading(true);
            const response = await winnersLeaderboardApi(user?.token);
            console.log(response, "response==");
            setLeaderboard(response?.data?.result || []);
        } catch (error) {
            console.log(error, "error-");
            setLeaderboard([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLeaderboard();
    }, []);

    return (
        <main className={classes.main}>
            <div className={classes.bgGlowOne}></div>
            <div className={classes.bgGlowTwo}></div>
            <div className={classes.bgGrid}></div>

            <section className={classes.wrapper}>
                <motion.div
                    className={classes.topBar}
                    initial={{ opacity: 0, y: -18 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                >
                    <motion.button
                        className={classes.backBtn}
                        onClick={() => navigate(-1)}
                        whileHover={{ x: -3, scale: 1.04 }}
                        whileTap={{ scale: 0.96 }}
                    >
                        <FaArrowLeft />
                    </motion.button>

                    <div className={classes.headerContent}>
                        <h1 className={classes.pageTitle}>{t("78")}</h1>

                        <div className={classes.headerBottomRow}>
                            <p className={classes.pageSubTitle}>{t("79")}</p>
                            <div className={classes.liveBadgeSmall}>{t("80")}</div>
                        </div>
                    </div>
                </motion.div>

                <motion.section
                    className={classes.listCard}
                    initial={{ opacity: 0, y: 28 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.45, delay: 0.25 }}
                >
                    <div className={classes.tableHead}>
                        <span>{t("81")}</span>
                        <span>{t("82")}</span>
                        <span>{t("83")}</span>
                    </div>

                    <div className={classes.rowsWrap}>
                        {loading ? (
                            <div className={classes.infoText}>{t("84")}</div>
                        ) : leaderboard.length === 0 ? (
                            <div className={classes.infoText}>{t("85")}</div>
                        ) : (
                            leaderboard.map((player, index) => {
                                const isLoggedInUser =
                                    String(player?.msisdn || "") === String(user?.msisdn || "");

                                return (
                                    <motion.div
                                        key={`${player.user_id}-${player.msisdn}-${index}`}
                                        className={`
                                            ${classes.playerRow}
                                            ${player.user_rank <= 3 ? classes.playerRowTop : ""}
                                            ${isLoggedInUser ? classes.loggedInUserRow : ""}
                                        `}
                                        initial={{ opacity: 0, x: -18 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.35, delay: 0.3 + index * 0.05 }}
                                        whileHover={{ scale: 1.01, x: 3 }}
                                    >
                                        <div className={classes.rankCol}>
                                            <div
                                                className={`${classes.rankPill} ${
                                                    isLoggedInUser ? classes.loggedInUserRankPill : ""
                                                }`}
                                            >
                                                #{player.user_rank}
                                            </div>
                                        </div>

                                        <div className={classes.playerCol}>
                                            {/* <div
                                                className={`${classes.smallAvatar} ${
                                                    isLoggedInUser ? classes.loggedInUserAvatar : ""
                                                }`}
                                            >
                                                {getInitials(player.msisdn || "U")}
                                            </div> */}

                                                     {player.user_image ? (
                                                <img
                                                    src={player.user_image}
                                                    alt={player.user_name || "User"}
                                                    className={classes.smallAvatarImage}
                                                />
                                            ) : (
                                                <div className={`${classes.smallAvatar} ${isLoggedInUser ? classes.loggedInUserAvatar : ""}`}>
                                                    {getInitials(player.user_name || t("86"))}
                                                </div>
                                            )}

                                            <div className={classes.playerMeta}>
                                                <div
                                                    className={`${classes.playerName} ${
                                                        isLoggedInUser ? classes.loggedInUserName : ""
                                                    }`}
                                                >
                                                    {player.msisdn || t("87")}{" "}
                                                    {isLoggedInUser ? t("88") : ""}
                                                </div>
                                            </div>
                                        </div>

                                        <div className={classes.timeCol}>
                                            <div
                                                className={`${classes.timeBadge} ${
                                                    isLoggedInUser ? classes.loggedInUserTimeBadge : ""
                                                }`}
                                            >
                                                <FaClock />
                                                {formatTime(player.total_time_spent_seconds)}
                                            </div>
                                        </div>
                                    </motion.div>
                                );
                            })
                        )}
                    </div>
                </motion.section>
            </section>
        </main>
    );
};

export default WinnersPage;